module.exports = __webpack_public_path__ + "static/media/bank-us-bank.90371853.svg";